export default __webpack_public_path__ + "c87d6e10782586bf40a74c1e64d5f826.png";